module.exports = __webpack_public_path__ + "static/media/Fairy.c8843e18.jpg";